const projects = 'projects';

/** Base Fetch Actions */
export const FETCH_PROJECTS_RESPONSE = `${projects}/FETCH_PROJECTS_RESPONSE` as const;
export const FETCH_PROJECTS_REQUEST = `${projects}/FETCH_PROJECTS_REQUEST` as const;
export const FETCH_PROJECTS_ERROR = `${projects}/FETCH_PROJECTS_ERROR` as const;

/** Base Update Actions */
export const UPDATE_PROJECT_RESPONSE = `${projects}/UPDATE_PROJECT_RESPONSE` as const;
export const UPDATE_PROJECT_REQUEST = `${projects}/UPDATE_PROJECT_REQUEST` as const;
export const UPDATE_PROJECT_ERROR = `${projects}/UPDATE_PROJECT_ERROR` as const;
